import { Component, OnInit, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import {DisplayProjectsComponent} from './display-projects/display-projects';
import {AddProjectComponent} from './add-project/add-project';

@Component({
  selector: 'app-projects',
  imports: [
    DisplayProjectsComponent,
    AddProjectComponent
  ],
  templateUrl: './projects.html',
  styleUrl: './projects.scss',
})
export class Projects implements OnInit {
  private route = inject(ActivatedRoute);
  private router = inject(Router);

  showModal = false;

  ngOnInit() {
    // Open the create-project modal when the global top-bar "New" is used (?new=1).
    this.route.queryParams.subscribe(params => {
      if (params['new']) {
        this.openModal();
        // Clear the flag so the same action can re-trigger next time.
        this.router.navigate([], { queryParams: { new: null }, queryParamsHandling: 'merge', replaceUrl: true });
      }
    });
  }

  openModal() {
    this.showModal = true;
  }

  closeModal() {
    this.showModal = false;
  }
}
